import Relay, { ProtocolHandler } from '@/app/modules/Metrics/classes/Relay';
import {
    EventsExtraData,
    ProtocolType,
    RuntimeEventData,
} from '@/app/modules/Metrics/types';
import { ProtocolTypes } from '@/modules/Metrix/types';
import ValueHolder from '@/app/modules/Metrics/classes/ValueHolder';
import CSCToDMPCloneStruct from '@/modules/Metrix/CSCToDMPCloneStruct';

/**
 * Не будем портить основной класс, навалим сюда
 */
export default class CustomRelay extends Relay {
    /**
     * Устанавливает дополнительные данные ДЛЯ ВСЕХ СООБЩЕНИЙ
     *
     * @param extraData
     */
    public addExtraData(extraData: EventsExtraData) {
        this.protocolHandlersMap.forEach((metricProtocol) => {
            metricProtocol.addExtraData(extraData);
        });
    }

    /**
     * @param eventObject
     * @param customValue
     */
    protected sendThroughProtocols(
        eventObject: Record<string, ValueHolder | any>,
        customValue?: RuntimeEventData
    ) {
        const CSCProtocolType = ProtocolTypes.CSC;
        const DMPProtocolType = ProtocolTypes.ONEDMP;

        let cscValue;
        if (eventObject.hasOwnProperty(CSCProtocolType)) {
            const CSCInitialValue = eventObject[CSCProtocolType];
            const protocolHandler = this.protocolHandlersMap.get(
                CSCProtocolType
            );
            if (protocolHandler && CSCInitialValue) {
                cscValue = protocolHandler.setValue(
                    CSCInitialValue,
                    customValue
                );
                protocolHandler.send();
            }
        }

        if (eventObject.hasOwnProperty(DMPProtocolType)) {
            const protocolHandler = this.protocolHandlersMap.get(
                DMPProtocolType
            );
            if (protocolHandler && cscValue) {
                // Gets runtime data from CSC
                protocolHandler.setValue(
                    new CSCToDMPCloneStruct(
                        cscValue,
                        eventObject[DMPProtocolType]
                    )
                );
                protocolHandler.send();
            }
        }

        this.protocolHandlersMap.forEach(function (
            protocolHandler: ProtocolHandler,
            type: ProtocolType
        ) {
            if (
                type !== DMPProtocolType &&
                type !== CSCProtocolType &&
                eventObject.hasOwnProperty(type)
            ) {
                protocolHandler.setValue(eventObject[type], customValue);
                protocolHandler.send();
            }
        });
    }
}
